import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import placeholder from "../../assets/images/fashion/product/12.jpg";
const WinnerList = ({ myData }) => {
  const [data, setData] = useState();
  useEffect(() => {
    setData(myData);
  }, [myData]);

  const columnDefs = [
    {
      name: "Image",
      cell: (row) => <ProfileImage row={row} />,
    },
    {
      name: "Username",
      selector: (row) => row.user.username,
      sortable: true,
    },
    {
      name: "User Type",
      selector: (row) => row.user.userType,
      sortable: true,
    },
    {
      name: "Winning Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
  ];

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

const ProfileImage = ({ row }) => {
  return (
    <div className="profile-image">
      <img src={row.user.profile ? row.user.profile : placeholder} alt="logo" />
    </div>
  );
};

export default WinnerList;
